import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Award, Users, Target, Zap } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar />
      
      <div className="pt-32 pb-20 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              About{' '}
              <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
                AION WISE Technologies
              </span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Empowering businesses with AI-powered solutions since 2015. 
              We transform challenges into opportunities through cutting-edge artificial intelligence.
            </p>
          </div>

          {/* Stats */}
          <div className="grid md:grid-cols-4 gap-6 mb-16">
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent mb-2">
                25+
              </h3>
              <p className="text-gray-400">Successful Projects Delivered</p>
            </div>
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent mb-2">
                15+
              </h3>
              <p className="text-gray-400">AI Specialists</p>
            </div>
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent mb-2">
                100%
              </h3>
              <p className="text-gray-400">Client Satisfaction</p>
            </div>
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent mb-2">
                24/7
              </h3>
              <p className="text-gray-400">Support Available</p>
            </div>
          </div>

          {/* Mission & Values */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-8">
              <Target className="w-12 h-12 text-orange-400 mb-4" />
              <h2 className="text-2xl font-bold text-white mb-4">Our Mission</h2>
              <p className="text-gray-300">
                To democratize AI technology and make it accessible to businesses of all sizes. 
                We believe every company deserves the competitive advantage that artificial 
                intelligence provides.
              </p>
            </div>
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-8">
              <Zap className="w-12 h-12 text-orange-400 mb-4" />
              <h2 className="text-2xl font-bold text-white mb-4">Our Vision</h2>
              <p className="text-gray-300">
                To be the world's most trusted AI solutions provider, recognized for innovation, 
                reliability, and transformative impact on businesses across all industries.
              </p>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="bg-gradient-to-r from-orange-600/20 to-amber-600/20 border border-orange-500/30 rounded-2xl p-8 mb-16">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">Why Choose AionWise?</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <Award className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-white font-semibold mb-2">Proven Expertise</h3>
                  <p className="text-gray-300">5+ years delivering successful AI projects across diverse industries</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Users className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-white font-semibold mb-2">Expert Team</h3>
                  <p className="text-gray-300">20+ certified AI specialists with deep technical knowledge</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Target className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-white font-semibold mb-2">Tailored Solutions</h3>
                  <p className="text-gray-300">Custom AI solutions designed specifically for your business needs</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Zap className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-white font-semibold mb-2">Rapid Deployment</h3>
                  <p className="text-gray-300">Fast implementation with minimal disruption to operations</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-white mb-6">Ready to Transform Your Business?</h2>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-orange-600 hover:bg-orange-700 text-white"
                onClick={() => window.location.href = '/#contact-form'}
              >
                Get Free Consultation
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-orange-500 text-orange-400 hover:bg-orange-500/10"
                onClick={() => window.location.href = '/#services'}
              >
                View Our Services
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutPage;
